/** Avviso del nome con un anno: lo stesso in V42 e nella competizione scritta al volo di V17. */
export const AVVISO_ANNO =
  "Il nome sembra contenere un anno: l'anno è della stagione, e la competizione l'anno prossimo andrebbe duplicata.";
